export default __webpack_public_path__ + "static/media/towel.647474bc.jpg";